import ScrollReveal from 'scrollreveal'

const sr = ScrollReveal();
const enableMobile = true;
const shortTrans = 250;
const longTrans = 500;

sr.reveal('.reveal', {
    delay: shortTrans,
    scale: 0.95,
    distance: '2rem',
    origin: 'bottom',
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-zoom-in', {
    delay: shortTrans,
    scale: 1.05,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq', {
    delay: shortTrans,
    scale: 0.95,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    interval: 50,
    reset: false,
})


sr.reveal('.reveal-seq-r', {
    delay: shortTrans, distance: '10%', origin: 'right',
    interval: 50,
    duration: longTrans, mobile: enableMobile, cleanup: true, reset: false,
})

sr.reveal('.reveal-seq-l', {
    delay: shortTrans,
    distance: '10%',
    origin: 'left',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq-t', {
    delay: shortTrans,
    distance: '10%',
    origin: 'top',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq-b', {
    delay: shortTrans,
    distance: '2rem',
    origin: 'bottom',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
    beforeReveal: (el) => {
        const countup = el.querySelector('.count-up');
        countup && countUpText(countup);
    }
});

window.addEventListener("load", () => {
    sr.delegate({ type: "resize" });

});

function countUpText(element, options = {}) {
    if (typeof CountUp === 'undefined') return;

    const text = element.textContent;
    const regex = /\d[\d,.]*/g;
    const matches = [...text.matchAll(regex)];

    if (!matches.length) return;

    let lastIndex = 0;
    element.innerHTML = '';

    matches.forEach((match) => {
        const value = match[0];
        const index = match.index;

        // Text vor der Zahl
        element.append(document.createTextNode(text.slice(lastIndex, index)));

        // Span für die Zahl
        const span = document.createElement('span');
        span.textContent = '0';
        element.append(span);

        const target = parseFloat(value.replace(/,/g, ''));

        const countUp = new CountUp(span, target, {
            duration: 2,
            separator: '',
            ...options
        });

        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }

        lastIndex = index + value.length;
    });

    // Restlicher Text
    element.append(document.createTextNode(text.slice(lastIndex)));
}